import type { ReactNode } from 'react';
import type { FeatureKey } from '@aiai/shared';
import { useFeature } from '../hooks/useEntitlements';
import { FeatureLocked } from './FeatureLocked';

/** Show `children` only while the workspace has `feature`; the locked notice when it doesn't. */
export function FeatureGate({ feature, children }: { feature: FeatureKey; children: ReactNode }) {
  const on = useFeature(feature);
  if (on === undefined) return null;
  if (!on) return <FeatureLocked feature={feature} />;
  return <>{children}</>;
}
